import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error file untyped
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
const KB_URL = 'https://knowledge.hubspot.com/integrations/view-the-order-object';
export const OrderAmountTooltipText = () => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "crmObjectBoard.orders.aggregationTooltip.description_jsx",
    elements: {
      Link: KnowledgeBaseButton,
      UIList: List,
      BR: () => /*#__PURE__*/_jsx("br", {})
    },
    options: {
      url: KB_URL
    }
  });
};